import { Navigate } from '@tanstack/react-router'
import { LoadingSpinner } from '@workspace/ui/components/loading-spinner'
import { useInvestorContext } from '../contexts/investor-guard'
import { useMcpSettingsQuery } from '../features/investor-assistant/hooks/use-investor-assistant'
import { AssistantLoadError } from './assistant-switch'

/**
 * The investor's start page, and where the removed pages (Dashboard, Feed, Deal Flow) now send
 * people: Search while the assistant is open for the account (so a new investor lands there after
 * onboarding), Settings otherwise (Search is closed to them). Change the target here when Home ships.
 */
export function InvestorHomeRedirect() {
  const { investor } = useInvestorContext()
  const { data, isLoading, error, refetch } = useMcpSettingsQuery()

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }
  if (error || !data?.data) return <AssistantLoadError onRetry={() => refetch()} />
  return (
    <Navigate
      to={data.data.assistantEnabled ? '/app/investor/$id/search' : '/app/investor/$id/settings'}
      params={{ id: investor.id }}
      replace
    />
  )
}
